import NewsletterCapture from "@/components/site/NewsletterCapture";

export default function Book() {
  return (
    <section
      id="book"
      data-testid="book-section"
      className="relative py-24 lg:py-32 bg-[#0a0a0a] border-t border-[#262626]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="overline overline-red mb-6">02 — Featured Book</div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Cover */}
          <div className="lg:col-span-5">
            <div className="relative bg-[#141414] border border-[#262626] p-6 sm:p-10 flex items-center justify-center">
              <div className="absolute top-4 left-4 overline text-white/40">ISBN 978-1834315553</div>
              <img
                src="https://m.media-amazon.com/images/I/51v9rHCRoXL._SY342_.jpg"
                alt="DECISION MARGIN book cover"
                data-testid="book-cover"
                className="w-full max-w-[320px] shadow-[0_30px_80px_-20px_rgba(217,45,32,0.35)]"
              />
              <div className="absolute bottom-4 right-4 overline text-white/40">Kismet Leads, LLC</div>
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-7">
            <h2 className="font-display font-extrabold text-5xl sm:text-6xl lg:text-7xl tracking-[-0.035em] leading-[0.9]">
              DECISION
              <br />
              <span className="text-[#d92d20]">MARGIN</span>
            </h2>
            <p className="mt-4 font-display text-lg sm:text-xl text-white/70 tracking-tight">
              Why Organizations Fail Before the Crisis Hits
            </p>

            <div className="mt-10 space-y-5 text-white/80 leading-relaxed text-[15px] sm:text-base">
              <p>
                Most organizations do not fail during the crisis itself. They fail
                long before it — quietly and almost invisibly — as communication
                weakens, decision-making slows, key knowledge becomes concentrated
                in too few people, and systems begin losing their ability to absorb
                pressure.
              </p>
              <p>
                Drawing from real-world experience in emergency management, public
                safety, and organizational leadership, Dr. Avory shows how resilient
                organizations think differently before disruption occurs. The book
                explores how leaders can recognize hidden fragility, protect
                decision-making capacity, improve coordination across silos, and
                maintain clarity when pressure rises.
              </p>
              <blockquote className="border-l-2 border-[#d92d20] pl-5 my-8 font-display text-xl sm:text-2xl text-white leading-snug tracking-tight">
                {"\u201CWhen crisis arrives, leaders rarely rise to the occasion. They fall to the level of preparation their systems can support.\u201D"}
              </blockquote>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href="https://a.co/d/09ek9ufb"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="book-buy-amazon"
                className="inline-flex items-center justify-center gap-3 bg-[#d92d20] hover:bg-[#b91d13] text-white px-7 py-4 text-[12px] font-semibold tracking-[0.18em] uppercase transition-colors"
              >
                Buy on Amazon →
              </a>
              <a
                href="#contact"
                data-testid="book-bulk-inquiry"
                className="inline-flex items-center justify-center gap-3 border border-[#404040] hover:border-white text-white px-7 py-4 text-[12px] font-semibold tracking-[0.18em] uppercase transition-colors"
              >
                Bulk Orders & Speaking
              </a>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-px bg-[#262626] border border-[#262626] max-w-md">
              <Meta k="Format" v="Hardcover" />
              <Meta k="Pages" v="79" />
              <Meta k="Lang" v="English" />
            </div>
          </div>
        </div>

        <NewsletterCapture />
      </div>
    </section>
  );
}

function Meta({ k, v }) {
  return (
    <div className="bg-[#0a0a0a] p-4">
      <div className="overline mb-1">{k}</div>
      <div className="text-white text-sm font-medium">{v}</div>
    </div>
  );
}
